// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__19Izc","consentsList":"PatientConsents_consentsList__3rnEW","consentsListEmpty":"PatientConsents_consentsListEmpty__DHsmb"};